module.exports = __webpack_public_path__ + "static/media/discount.b67a8f5c.svg";